export type Market = {
  code: string
  symbol: string
  locale: string
}

/**
 * La tienda vende únicamente en pesos argentinos (ARS).
 */
export const ARS_MARKET: Market = { code: 'ARS', symbol: '$', locale: 'es-AR' }

export function detectMarket(): Market {
  return ARS_MARKET
}

export function formatAmount(amount: number, market: Market = ARS_MARKET): string {
  const digits = Number.isInteger(amount) ? 0 : 2
  return new Intl.NumberFormat(market.locale, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(amount)
}
